export default __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/loader_ur_250x250.3662e1fc.gif";